import Vue from 'vue'


import "core-js/stable";
import "regenerator-runtime/runtime";

import allResources from './allResources.vue'
import calendar from './calendar.vue'

// WiV.vue (old Work in Vancouver job board, #vue-element mount) removed
// 2026-07-15 — replaced by the standalone Vue3/Vite SPA at #wiv-app.
// vue2-google-maps went with it (WiV was its only consumer).

if (document.querySelector('#vue-element_Resources')) {
  new Vue({
    el: '#vue-element_Resources',
    render: h => h(allResources)
  }); 
}

if (document.querySelector('#calendarVue')) {
  new Vue({
    el: '#calendarVue',
    render: h => h(calendar)
  });
}

/* new Vue({
  el: '#calendarVue',
  render: h => h(calendar)
}); */

/* 
            let mapArgs = {
                zoom: 11,
                // center: vancouver,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles:[ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#b5b5b5" }, { "visibility": "on" }, { "weight": "2.00" } ] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road.arterial", "elementType": "all", "stylers": [ { "visibility": "on" }, { "color": "#b5b5b5" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": "#cae9f2" }, { "visibility": "on" } ] } ]
            }; */ 

            //preffered package -- parte do programa --leonardo


// WEBPACK FOOTER //
// ./src/main.js